import { refreshIcons } from '../../base/utils.js';
export function initAccordion() {
    document.querySelectorAll('.accordion-button').forEach(button => {
        if (button.dataset.initialized) return;
        button.dataset.initialized = 'true';

        const item = button.closest('.accordion-item');
        const collapse = item.querySelector('.accordion-collapse');

        if (collapse && collapse.classList.contains('show')) {
            item.classList.add('active');
        }

        button.addEventListener('click', function () {
            const item = this.closest('.accordion-item');
            const collapse = item.querySelector('.accordion-collapse');
            const parent = this.closest('.accordion');

            const parentId = collapse.getAttribute('data-bs-parent');

            if (parentId) {
                const parentEl = document.querySelector(parentId) || parent;
                if (parentEl) {
                    parentEl.querySelectorAll('.accordion-item.active').forEach(activeItem => {
                        if (activeItem !== item) {
                            activeItem.classList.remove('active');
                            const activeCollapse = activeItem.querySelector('.accordion-collapse');
                            if (activeCollapse) activeCollapse.classList.remove('show');
                        }
                    });
                }
            }

            item.classList.toggle('active');
            collapse.classList.toggle('show');
        });
    });
}
